import React, { useState } from "react";
import "./dmsTrustedBrands.css";

import brand1 from "../../assets/clients/procuremaster_logo_transparent.png";
import brand2 from "../../assets/clients/chatakdarLogo.png";
import brand3 from "../../assets/clients/tauciesLogo.png";
import brand4 from "../../assets/clients/rahejaLogo.png";
import brand5 from "../../assets/clients/mallowsLogo.png";
import brand6 from "../../assets/clients/iora.png";

import DmsBookingModal from "./dmsBookingModal";
import { FiArrowRight } from "react-icons/fi";

const logos = [
  {
    src: brand1,
    alt: "Procure Master",
    variant: "light",
  },
  {
    src: brand2,
    alt: "Chatakdar",
    variant: "light",
  },
  {
    src: brand3,
    alt: "Taucies",
    variant: "dark",
  },
  {
    src: brand4,
    alt: "Raheja Realty",
    variant: "light",
  },
  {
    src: brand5,
    alt: "Mallows Beverages",
    variant: "light",
  },
  {
    src: brand6,
    alt: "Iora",
    variant: "light",
  },
];

const marqueeLogos = [...logos, ...logos];

const DmsTrustedBrands = () => {
  const [showDmsModal, setShowDmsModal] = useState(false);

  return (
    <>
      <section className="dms-trusted-section">
        <div className="dms-trusted-bg-orb dms-trusted-bg-orb-left"></div>
        <div className="dms-trusted-bg-orb dms-trusted-bg-orb-right"></div>

        <div className="container">
          <div className="dms-trusted-header" data-aos="fade-up">
            <div className="dms-trusted-label">
              <span className="dms-trusted-label-dot"></span>
              OUR CLIENTS
            </div>

            <h2>
              Trusted by Businesses.
              <span> Built for Connected Distribution.</span>
            </h2>

            <p>
              TechCognics helps businesses connect distributors, sales teams,
              orders, inventory and retailers through one intelligent
              distribution management platform.
            </p>
          </div>

          <div
            className="dms-client-ribbon"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="dms-client-ribbon-top">
              <div className="dms-ribbon-title">
                <span className="dms-ribbon-live-dot"></span>
                <span>POWERING BUSINESSES WITH TECHCOGNICS DMS</span>
              </div>

              <div className="dms-ribbon-index">06+ CLIENT BRANDS</div>
            </div>

            <div className="dms-client-marquee">
              <div className="dms-marquee-fade dms-marquee-fade-left"></div>
              <div className="dms-marquee-fade dms-marquee-fade-right"></div>

              <div className="dms-client-track">
                {marqueeLogos.map((logo, index) => (
                  <div
                    className={`dms-client-card ${
                      logo.variant === "dark" ? "dms-client-card-dark" : ""
                    }`}
                    key={`${logo.alt}-${index}`}
                  >
                    <img src={logo.src} alt={logo.alt} loading="lazy" />
                  </div>
                ))}
              </div>
            </div>

            <div className="dms-client-ribbon-bottom">
              <span className="dms-ribbon-line"></span>

              <span>
                Connected distribution
                <strong> • </strong>
                Smarter operations
                <strong> • </strong>
                Better business visibility
              </span>

              <span className="dms-ribbon-line"></span>
            </div>
          </div>

          <div
            className="dms-trusted-cta"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <button
              type="button"
              className="dms-trusted-demo-btn"
              onClick={() => setShowDmsModal(true)}
            >
              Book a Demo
              <span>
                <FiArrowRight />
              </span>
            </button>

            <div className="dms-trusted-cta-text">
              <span className="dms-trusted-cta-line"></span>
              <span>
                Trusted by businesses to simplify and scale their distribution
                operations.
              </span>
              <span className="dms-trusted-cta-line"></span>
            </div>
          </div>
        </div>
      </section>

      <DmsBookingModal
        show={showDmsModal}
        onClose={() => setShowDmsModal(false)}
      />
    </>
  );
};

export default DmsTrustedBrands;
